export enum QueueOptions {
  WorkdaySupplierDomestic = 'WorkdaySupplierDomestic',
  WorkdaySupplierForeign = 'WorkdaySupplierForeign',
  PlusAllianceStudentGroup = 'PlusAllianceStudentGroup',
  BfitArchive = 'BfitArchive',
  DataWarehouse = 'DataWarehouse'
}